export default __webpack_public_path__ + "static/1883-7b0f37a1adcadd181c0ef5582138044b.gif";